import TokenService from "services/token.service";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

type Tokens = {
  accessToken: string;
  client: string;
  uid: string;
  expiry: string;
};

function getTokensFromUrl(search: string): Tokens {
  const params = new URLSearchParams(search);

  const accessToken = params.get("access-token") || "";
  const client = params.get("client") || "";
  const uid = params.get("uid") || "";
  const expiry = params.get("expiry") || "";

  return {
    accessToken,
    client,
    uid,
    expiry,
  };
}

function updateTokenService(tokens: Tokens) {
  TokenService.set("accessToken", tokens.accessToken);
  TokenService.set("client", tokens.client);
  TokenService.set("uid", tokens.uid);
  TokenService.set("expiry", tokens.expiry);
}

export const redirectIfUser = async ({ request }: LoaderFunctionArgs) => {
  if (request.url.includes("access-token")) {
    const tokens = getTokensFromUrl(new URL(request.url).search);
    updateTokenService(tokens);
  }
  if (Boolean(TokenService.get("accessToken"))) return redirect("/");
  return null;
};
